<template>
  <div class="w-full h-full" v-loading="loadingEngine">
    <img
      id="playerEngineId"
      class="engineVideo w-full"
      v-if="modelSetting.cloudRenderLoadMode === 'img'"
    />
    <video id="playerEngineId" autoplay playsinline muted class="engineVideo w-full" v-else></video>
    <!-- 模型进度条 -->
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
  </div>
</template>

<script>
import { instance as cloudRender } from 'wiz-cloud-render-vulkan'
import SceneLoader from '../../assets/js/scene/SceneLoader'

const PlayerProgress = () => {
  return import('./PlayerProgress')
}
export default {
  name: 'ModelView',
  components: { PlayerProgress },
  props: {
    loadModelType: {
      type: String,
      defalut: 'modelFileId',
    },
    sceneOptions: {
      type: Object,
      defalut: () => {
        return {
          isEnableGis: false,
          latitude: 0,
          longitude: 0,
          name: '',
          id: '',
          folderId: '',
          jsonData: '',
        }
      },
    }
  },
  data() {
    return {
      player: null, // player实例

      loadingEngine: false, // 引擎加载状态
      showLoadProgress: false, // 进度条显隐
      loadType: '', // 进度条类型
      loadPercentage: 0, // 进度条值
      sceneFileList: [],
      fileCount: 0,
      sceneData: {},
      sceneRootNode: 0,
      loadedModels: [],
    }
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
    // 云渲染协议
    cloundProtocol() {
      return this.modelSetting.cloudProtocol || 'ws'
    },
    // 云渲染服务路径
    cloundServerPath() {
      return this.modelSetting.cloudServerPathVulkan || 'renderapi.wiz.top:7082'
    }
  },
  watch: {
    sceneOptions: {
      async handler(data) {
        if (data.longitude && data.latitude && this.player) {
          this.sceneLoader.moveToLLH(Number(data.longitude), Number(data.latitude))
          const elevation = (
            await this.player.Native.GisPlatform.queryDEM([[data.longitude, data.latitude, 0]])
          )[0]
          const root = await this.player.Native.Node.getRoot()
          // 在跟节点集合中查找我们设置的场景的跟节点
          const rootinfo = await this.player.Native.Node.getProperty(root, ['children'])
          if (rootinfo.children[0]) {
            const mat = await this.player.Native?.GisPlatform.makeGisTransform([
              this.sceneOptions.longitude,
              this.sceneOptions.latitude,
              elevation,
            ])
            await this.player.Native?.Node.setProperty(rootinfo.children[0].node, {
              wholeMatrix: mat,
            })
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.runPlayer()
  },
  beforeDestroy() {
    if (this.player) {
      this.player.exit()
    }
  },
  methods: {
    // 加载进度
    loadNodeCallback(percentage) {
      this.loadPercentage = percentage
    },
    // 加载player引擎
    async runPlayer() {
      this.loadingEngine = true
      window.cloudRender = cloudRender
      const { data } = await cloudRender.Engine.loadEngine({
        signalServer: `${this.cloundProtocol}://${this.cloundServerPath}`,
        options: {
          openDebug: true,
          DomType: this.modelSetting.cloudRenderLoadMode === 'img' ? 1 : 0,
          videoDom: document.getElementById('playerEngineId'), // 绑定视频标签
          imgDom: document.getElementById('playerEngineId'), // 绑定视频标签
          userTimeout: 1000 * 60 * 60, // 用户操作超时设置，毫秒
          exitTimeout: 1000 * 60 * 1, // 用户超时后多久断开会话
          maxTimeout: 1000, // 会话超时时间，允许掉线后引擎保存多久，在该时间内可重新连接到会话，否则会创建新的会话
        },
      })
      this.player = data.getDataInfo()
      // 实例化完成将实例化后的player传出去
      this.$emit('sendPlayer', this.player)
      this.initPlayer()
    },
    // 监听模型加载状况
    checkModelLoad(bool) {
      this.showLoadProgress = bool
      this.loadPercentage = 0
      !bool && this.$emit('loadModelEnd')
    },
    // 初始化player
    async initPlayer() {
      // 设置点选时其他节点半透明
      // cloudRender.Setting.set([
      //   { name: 'display.bgTransparent.enable', value: true },
      //   { name: 'display.bgTransparent.alpha', value: 0.5 },
      // ])
      this.loadingEngine = false
      const settingsFileUrl = `data://../apps/${this.modelSetting.folderName}/settings.json`
      const res = await cloudRender.Setting.getSettingData(settingsFileUrl)
      const settingsData = res.data
      if (settingsData) {
        const defaultSettings = JSON.parse(settingsData)
        await cloudRender.Setting.set(defaultSettings.Show)
      }
      // 获取到经纬度添加地图
      if (this.sceneOptions.isEnableGis) {
        // await cloudRender.GIS.loadGis(this.modelSetting.globalMapPath)
        await player.Native.GisPlatform.loadMap(this.modelSetting.globalMapPath)
      }
      this.sceneLoader = new SceneLoader(
        this.player,
        this.sceneOptions,
        this.progressMsg,
        this.downloadMsg,
        this.downloadMaterialMsg,
        this.checkModelLoad,
        this.loadNodeCallback
      )
    },
    // 监听下载模型的开始结束
    downloadMsg(bool, file, err) {
      this.loadPercentage = 0
      this.showLoadProgress = bool
      if (err) {
        this.$message.warning(`下载文件失败，${file}, ${err}`)
      }
    },

    // 监听下载材质的开始结束
    downloadMaterialMsg(bool, file, err) {
      this.showLoadProgress = bool
      this.loadPercentage = 0
      if (err) {
        this.$message.warning(`下载贴图文件失败，${file}, ${err}`)
      }
    },

    // 监听下载的进度
    progressMsg(file, bytesReceived, bytesTotal) {
      if (bytesTotal) {
        this.loadPercentage = (bytesReceived / bytesTotal) * 100
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.engineVideo {
  height: calc(100% + 15px);
  object-fit: fill;
}

::v-deep .el-loading-mask {
  background-color: transparent !important;
}
</style>
